/** True when the Maps JavaScript API has finished loading. */
export function isGoogleMapsReady(): boolean {
  return typeof window !== "undefined" && Boolean(window.google?.maps);
}

export const PLACES_STATUS_OK = "OK";
